import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";

export default function AuthGuard() {
    const { user, loading } = useAuthStore();

    if (loading)
        return (<p>loading...</p>)

    if (!user)
        return <Navigate to="/login" replace />;

    return <Outlet />;
}